(function() {

  /******************************
   * Helper: cm-Werte parsen
   ******************************/
  function parseNumberFromCm(str) {
    return parseFloat(String(str || "").replace("cm", "").replace(",", ".").trim());
  }

  function getTargetSize() {
    const wInput = document.getElementById("target-width-cm");
    const hInput = document.getElementById("target-height-cm");
    if (!wInput || !hInput) return null;

    const w = parseNumberFromCm(wInput.value);
    const h = parseNumberFromCm(hInput.value);

    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) return null;
    return { width: w, height: h };
  }

  /******************************
   * Variant-Cap aus Option lesen
   * erwartet: "bis 0.1234 m²"
   ******************************/
  function parseAreaCapFromOption(value) {
    if (!value) return null;

    // nimmt die erste Zahl im String (0.1234) egal ob "m²" oder "m2"
    const m = String(value).replace(",", ".").match(/(\d+(\.\d+)?)/);
    if (!m) return null;

    const cap = parseFloat(m[1]);
    if (isNaN(cap) || cap <= 0) return null;
    return cap; // m²
  }

  /******************************
   * Beste Variante wählen (Aufrunden)
   ******************************/
  function selectBestVariant() {
    const select = document.querySelector(
      '.product-variant-container[data-js-product-variant-container="select"]'
    );
    if (!select) return;

    const target = getTargetSize();
    if (!target) return;

    const options = Array.from(select.options);
    if (!options.length) return;

    // Fläche in m²
    const targetArea = (target.width * target.height) / 10000;

    let bestFit = null;
    let bestCap = null;

    let closest = null;
    let closestDiff = null;

    options.forEach(opt => {
      const cap = parseAreaCapFromOption(opt.value);
      if (!cap) return;

      // 1) Best Fit: kleinste Cap, die gross genug ist
      if (cap >= targetArea) {
        if (bestFit == null || cap < bestCap) {
          bestFit = opt;
          bestCap = cap;
        }
      }

      // 2) Fallback: Cap am nächsten
      const diff = Math.abs(cap - targetArea);
      if (closest == null || diff < closestDiff) {
        closest = opt;
        closestDiff = diff;
      }
    });

    const chosen = bestFit || closest;
    if (!chosen) return;

    if (select.value !== chosen.value) {
      select.value = chosen.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  /******************************
   * Input-Änderungen überwachen
   ******************************/
  function setupWatchers() {
    const wInput = document.getElementById("target-width-cm");
    const hInput = document.getElementById("target-height-cm");
    if (!wInput || !hInput) return;

    let lastW = wInput.value;
    let lastH = hInput.value;

    ["input", "change", "blur"].forEach(evt => {
      wInput.addEventListener(evt, selectBestVariant);
      hInput.addEventListener(evt, selectBestVariant);
    });

    setInterval(function() {
      const curW = wInput.value;
      const curH = hInput.value;

      if (curW !== lastW || curH !== lastH) {
        lastW = curW;
        lastH = curH;
        selectBestVariant();
      }
    }, 200);
  }

  function init() {
    setupWatchers();
    selectBestVariant();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
